/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { CssTooltip } from '@livechat/design-system'

import refreshIcon from '../assets/icons/refresh.svg'
import { ExportToCSV } from '../components'

const managerCss = (isDisabled) => css`
  display: flex;
  align-items: center;
  margin: 20px 0 30px 0;

  .amount {
    margin-right: 1px;
    font-size: 17px;
    margin-bottom: ${isDisabled ? '-3px' : '0px'};
  }

  .counter {
    display: inline-block;
    color: #3f8cff;
    font-weight: 300;
    display: flex;
    align-items: center;

    .refresh {
      width: 23px;
      margin-bottom: -3px;
      cursor: ${isDisabled ? 'default' : 'pointer'};
      opacity: ${isDisabled ? '0.5' : '1'};
    }
  }
`

const RaportManager = ({
  response,
  refresh,
  setIsTooltipOpen,
  isTooltipOpen,
  surveyName,
  structure,
  surveysLoading,
  isDisabled,
}) => {
  return (
    <div css={managerCss(isDisabled)}>
      <span className="counter">
        <span className="amount">
          <b>{response ? response.length : 0}</b> answers in total
        </span>
        {surveysLoading ? (
          <img className="refresh" src={refreshIcon} alt="refresh" />
        ) : (
          <div style={{ display: 'inline-block', position: 'relative' }}>
            <img
              alt="refresh"
              className="refresh"
              src={refreshIcon}
              onClick={refresh}
              onMouseEnter={() => setIsTooltipOpen(true)}
              onMouseLeave={() => setIsTooltipOpen(false)}
            />
            <CssTooltip
              placement="bottom"
              isVisible={isTooltipOpen}
              width="150px"
              zIndex={100}
            >
              <div
                css={css`
                  max-width: 150px;
                  text-align: center;
                `}
              >
                Refresh answers
              </div>
            </CssTooltip>
          </div>
        )}
      </span>
      <ExportToCSV
        surveyName={surveyName}
        structure={structure}
        response={response}
        surveysLoading={surveysLoading}
      />
    </div>
  )
}

export default RaportManager
